var map = {
	"./australia.svg": "2b16",
	"./austria.svg": "5b5b",
	"./bangladesh.svg": "3eb5",
	"./belgium.svg": "de31",
	"./brazil.svg": "9c95",
	"./brunei.svg": "274f",
	"./cambodia.svg": "e5ed",
	"./canada.svg": "12e8",
	"./china.svg": "af3f",
	"./costa_rica.svg": "b09f",
	"./denmark.svg": "c925",
	"./egypt.svg": "db0c",
	"./findland.svg": "68b9",
	"./france.svg": "2ced",
	"./germany.svg": "c075",
	"./greece.svg": "358a",
	"./hongkong.svg": "2828",
	"./india.svg": "34ef",
	"./indonesia.svg": "87a7",
	"./italy.svg": "7d4e",
	"./jepang.svg": "33be",
	"./kazakhstan.svg": "b679",
	"./korea.svg": "c3f3",
	"./kuwait.svg": "2b59",
	"./macau.svg": "c5dc",
	"./malaysia.svg": "1df3",
	"./mexico.svg": "6ff2c",
	"./monaco.svg": "7e94",
	"./morocco.svg": "b442",
	"./netherland.svg": "64ad",
	"./newzeland.svg": "6973",
	"./oman.svg": "c32a",
	"./pakistan.svg": "43d9",
	"./peru.svg": "8213",
	"./philippines.svg": "10c1",
	"./qatar.svg": "2b96",
	"./saudi_arabia.svg": "58fb",
	"./singapore.svg": "2afa",
	"./south_africa.svg": "ef54",
	"./spain.svg": "6b8e",
	"./sri_lanka.svg": "650b",
	"./sweden.svg": "f847",
	"./taiwan.svg": "547d",
	"./thailand.svg": "e2ea",
	"./timor-leste.svg": "f6b7",
	"./turkey.svg": "409c",
	"./uk.svg": "821e",
	"./uni_emirate_arab.svg": "464a",
	"./usa.svg": "0d82",
	"./venezuela.svg": "a6fe",
	"./vietnam.svg": "aa10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eac0";